import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from "mdbreact";
import React, { Component } from "react";
import Dropzone from "react-dropzone";
import domain from ".././../../../domain";
import axios from "axios";
var validExt = ".pdf, .ppt, .docx, .doc, .zip, .tar.gz, .tar, .rar";

//function for validate file size
var maxSize = "30720";
export default class PresentationModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      file: null,
      uploaded: 0,
      status: false,
    };
    this.onDrop = this.onDrop.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  toggle = () => {
    this.setState({
      modal: !this.state.modal,
      uploaded: 0,
      file: null,
    });
  };
  onDrop([file]) {
    this.setState({
      file: file,
    });
  }
  validateFile = (photo) => {
    if (this.fileExtValidate(photo) && this.fileSizeValidate(photo))
      return true;
    else return false;
  };

  fileExtValidate = (fdata) => {
    var filePath = fdata.name;

    var getFileExt = filePath
      .substring(filePath.lastIndexOf(".") + 1)
      .toLowerCase();
    var pos = validExt.indexOf(getFileExt);
    if (pos < 0) {
      alert(
        "This file is not allowed, please upload valid file. Allowed file formats are .pdf, .ppt, .docx, .doc, .zip, .tar.gz, .tar or .rar.  The file size cannot exceed 30MB"
      );
      return false;
    } else {
      return true;
    }
  };

  fileSizeValidate = (fdata) => {
    if (fdata.size) {
      var fsize = fdata.size / 1024;
      // alert(fsize)
      if (fsize > maxSize) {
        alert(
          "Maximum file size exceeds, Allowed file size is: " + fsize + "KB"
        );
        return false;
      } else {
        return true;
      }
    }
  };
  handleSubmit = (e) => {
    e.preventDefault();

    if (!this.state.file) {
      alert("Please upload the presentation");
      return false;
    }
    if (this.validateFile(this.state.file)) {
      let result = window.confirm("Please check the file before submitting.");
      if (result) {
        var data = new FormData();

        //      var config = {
        //     onUploadProgress: (progressEvent) => {
        //       this.setState({
        //         uploaded: progressEvent.loaded / progressEvent.total
        //       });
        //     }
        //   };
        data.append("presentation", this.state.file);
        data.append("course_session_id", this.props.session.course_session_id);
        axios
          .post(`${domain.DBServer}/upload-presentation`, data)
          .then((res) => {
            this.setState({
              status: true,
            });

            if (res.data.success) {
              alert(res.data.msg);
              window.location.reload();
            }
          });
      }
    } else {
      return false;
    }
  };
  render() {
    // let sessionupload
    if (this.props.session) {
      console.log(this.props.session);
    }

    return (
      <div style={{ fontFamily: "helvetica" }}>
        <Button color="primary" onClick={this.toggle}>
          Upload
        </Button>
        <Modal isOpen={this.state.modal} toggle={this.toggle} size="lg">
          <ModalHeader toggle={this.toggle}></ModalHeader>
          <ModalBody>
            <form
              className="form-horizontal"
              method="post"
              encType="multipart/form-data"
              onSubmit={this.handleSubmit}
            >
              <h2 align="center" style={{ color: "#6f42c1" }}>
                Upload Presentation
              </h2>
              <h4 align="center" style={{ color: "#6f42c1" }}>
                {this.props.session.lecturer_name}
              </h4>
              <h4 align="center" style={{ color: "#6f42c1" }}>
                {this.props.session.title}
              </h4>
              {this.props.session.presentation ? (
                <div className="alert alert-success">
                  <strong>
                    Available presentation: {this.props.session.presentation}
                  </strong>
                </div>
              ) : (
                <div className="alert alert-success">
                  <strong>No presentations uploaded yet</strong>
                </div>
              )}
              <div
                style={{
                  float: "left",
                  width: "calc(100% + 30px)",
                  textAlign: "center",
                  backgroundColor: "#fafafa",
                  margin: "0 -15px 15px",
                  padding: "15px",
                  boxShadow: "0 0 2px rgba(0, 0, 0, 0.25)",
                }}
              >
                <Dropzone
                  multiple={false}
                  ref={(node) => {
                    this.dropzone = node;
                  }}
                  onDrop={this.onDrop}
                  id="photo"
                  style={{
                    width: "calc(100% + 10px)",
                    height: "250px",
                    borderWidth: 2,
                    borderColor: "rgb(102, 102, 102)",
                    borderStyle: "dashed",
                    borderRadius: 5,
                    margin: "16px auto",
                  }}
                >
                  Drag and drop a image file to start uploading.
                  <br />
                  <br />
                  <div className="alert alert-warning">
                    The file format can be .pdf, .ppt, .docx, .doc, .zip,
                    .tar.gz, .tar or .rar. The file size cannot exceed 30MB
                  </div>
                  <Button type="button">Upload Presentation</Button>
                  <br />
                  {this.state.file != null ? (
                    <div>
                      <h5>Uploading {this.state.file.name} </h5>
                    </div>
                  ) : null}
                  <div></div>
                </Dropzone>
              </div>
              <Button variant="raised" color="secondary" type="submit">
                {" "}
                Submit &amp; Upload
              </Button>
            </form>
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={this.toggle}>
              Close
            </Button>{" "}
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
